const initialPurchaseOrder = {
    purchaseorders: [],
    singlepurchaseorders : [],
    pendingpos : [],
    purchaseordermessages : {},
};

const purchaseorderReducer = (purchaseorder = initialPurchaseOrder, action) => {
    switch (action.type) {
        case 'GET_PURCHASE_ORDER':
            return {
                ...purchaseorder, purchaseorders: action.payload.data
            };
        case "ADD_PURCHASE_ORDER":
            return {
                ...purchaseorder, purchaseordermessages: action.payload.data
            };
        case "UPDATE_PURCHASE_ORDER":
            return {
                ...purchaseorder, purchaseordermessages: action.payload.data
            };
        case "DELETE_PURCHASE_ORDER":
            return {
                ...purchaseorder, purchaseordermessages: action.payload.data
            };   
        case "GET_SINGLE_PURCHASE_ORDER":
            return {
                ...purchaseorder, singlepurchaseorders: action.payload.data
            }; 
        case "GET_PENDING_PURCHASE_ORDER":
            return {
                ...purchaseorder, pendingpos: action.payload.data
            };   
            
                
            
        default:return purchaseorder;

    }
}
export default purchaseorderReducer;